<template>
  <div class="contact-maxbox">
    <div class="contact-minbox">
      <div class="minbox-right">
        <div class="title">
          <div class="title-max">联系我们 <span class="title-min">Contact Us</span></div>
        </div>
        <div class="address">
          地址：上海市杨浦区荆州路168号安联大厦509室
        </div>
        <div class="contacts">
          <div class="lable">联系人：</div>
          <div>
            <div><span class="name">李<span class="booth"></span>浩</span>（客户经理）  <span class="phone">电话：13524534404</span> 邮箱：lihao@ymlogistics.net</div>
            <div><span class="name">陈耀红</span>（客户经理） <span class="phone">电话：18621310071</span>  邮箱：chenyaohong@ymlogistics.net</div>
          </div>
        </div>
      </div>
      <div class="minbox-left">
        <img
          class="map-image"
          src="https://ym-attached-file.oss-cn-shanghai.aliyuncs.com/images/home_address.png"
          alt="公司地址"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newContact",
};
</script>

<style lang="less" scoped>
.contact-maxbox{
  width: 100%;
  padding: 20px 0 70px;
  box-sizing: border-box;
  .contact-minbox{
    width: 1300px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    .minbox-left{
      width: 550px;
      height: 228px;
      .map-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .minbox-right{
      display: flex;
      flex-direction: column;
      line-height: 40px;
      .contacts{
        display: flex;
        .name{
          display: inline-block;
          width: 44px;
          
          .booth{
            display: inline-block;
            width: 14px;
          }
        }
        .phone{
          margin:0 40px;
        }
      }
    }
  }
}
.title{
  margin-bottom: 20px;
  .title-max {
    font-size: 26px;
    color: #91BE42;
  }
  .title-min {
    font-size: 20px;
    color: #DFDFDF;
  }
}
</style>